module.exports = __webpack_public_path__ + "static/media/clock.0c0437ff.svg";